Drupal.behaviors.particleTooltips = {
  attach() {},
};
